import { Vue, Component, Prop } from "vue-property-decorator";
import replace from "lodash-es/replace";
import Chartist from "chartist";

@Component
class KeyFigures extends Vue {
    @Prop() public chartLabels: any;
    @Prop() public chartSeries: any;
    @Prop() public chartLegends: any;
    @Prop() public legendClassName: any;

    public chartData = {};
    public chartOptions = {
        axisX: {
            // The offset of the labels to the chart area
            offset: 30,
            // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
            position: "end",
            // Allows you to correct label positioning on this axis by positive or negative x and y offset.
            labelOffset: {
                x: 0,
                y: 0,
            },
            // If labels should be shown or not
            showLabel: true,
            // If the axis grid should be drawn or not
            showGrid: true,
            // Interpolation function that allows you to intercept the value from the axis label
            labelInterpolationFnc: Chartist.noop,
            // Set the axis type to be used to project values on this axis. If not defined, Chartist.StepAxis will be used for the X-Axis, where the ticks option will be set to the labels in the data and the stretch option will be set to the global fullWidth option. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
            type: undefined,
        },
        // Options for Y-Axis
        axisY: {
            // The offset of the labels to the chart area
            offset: 40,
            // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
            position: "start",
            // Allows you to correct label positioning on this axis by positive or negative x and y offset.
            labelOffset: {
                x: 0,
                y: 0,
            },
            // If labels should be shown or not
            showLabel: true,
            // If the axis grid should be drawn or not
            showGrid: true,
            // Interpolation function that allows you to intercept the value from the axis label
            labelInterpolationFnc: Chartist.noop,
            // Set the axis type to be used to project values on this axis. If not defined, Chartist.AutoScaleAxis will be used for the Y-Axis, where the high and low options will be set to the global high and low options. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
            type: undefined,
            // This value specifies the minimum height in pixel of the scale steps
            scaleMinSpace: 20,
            // Use only integer values (whole numbers) for the scale steps
            onlyInteger: false,
        },
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // If the line should be drawn or not
        showLine: true,
        // If dots should be drawn or not
        showPoint: true,
        // If the line chart should draw an area
        showArea: false,
        // The base for the area chart that will be used to close the area shape (is normally 0)
        areaBase: 0,
        // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
        lineSmooth: true,
        // If the line chart should add a background fill to the .ct-grids group.
        showGridBackground: false,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: {
            top: 15,
            right: 15,
            bottom: 5,
            left: 10,
        },

        stackBars: true,
        plugins: [
            // Chartist.plugins.ctAccessibility({}),
            Chartist.plugins.tooltip({
                tooltipOffset: {
                    x: 0,
                    y: -20,
                },
                appendToBody: true,
                tooltipFnc(_meta: any, value: any) {
                    let tooltipText = "";
                    const options = Chartist.plugins.tooltip;
                    if (value) {
                        if (options.currency) {
                            if (options.currencyFormatCallback != undefined) {
                                value = options.currencyFormatCallback(value, options);
                            } else {
                                value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                            }
                        }
                        value = '<span class="chartist-tooltip-value">' + value + "</span>";
                        tooltipText += value;
                    }
                    return tooltipText;
                },
            }),
            Chartist.plugins.legend({
                className: this.legendClassName,
                clickable: false,
                position: "bottom",
            }),
        ],
    };

    public created() {
        this.getChartData();
    }

    public getChartData() {
        // Get data from freemarker
        const series = this.chartSeries;
        const labels = this.chartLabels;
        let legends = this.chartLegends;
        if (series && labels) {
            // Get series data
            const seriesList = [series.split("],")];
            legends = legends.substring(0, legends.lastIndexOf(","));
            const seriesListFinal = [];
            for (let x = 0; x < seriesList[0].length - 1; x++) {
                seriesList[0][x] = seriesList[0][x].substring(1); // Remove "[" from the seriesList String

                const stringArray = [seriesList[0][x].split(",")];
                const legendsList = legends.split(",");
                const numberArray = [];

                // seriesList data from String into real numbers
                for (let y = 0; y < stringArray[0].length; y++) {
                    numberArray[y] = +stringArray[0][y];
                }

                const serieObject = {
                    name: legendsList[x],
                    data: numberArray,
                };

                seriesListFinal.push(serieObject);
            }

            // Get label data
            const labelsList = labels.split(",");
            for (let x = 0; x < labelsList.length; x++) {
                labelsList[x] = replace(labelsList[x], new RegExp(" ", "g"), "");
            }

            this.chartData = {
                labels: labelsList,
                series: seriesListFinal,
            };
        }
    }
}

export { KeyFigures };



// WEBPACK FOOTER //
// ./src/scripts/components/key-figures.ts